import { render } from "./senior.vue?vue&type=template&id=539e9b4c"
import script from "./senior.vue?vue&type=script&lang=js"
export * from "./senior.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__